import layoutStore from "./layout";
import employeeStore from "./employee";
const rootStore = {
    layoutStore,
    employeeStore,
}
export default rootStore;